"use client";

import { useLenis } from "lenis/react";
import { useCallback, useEffect, useLayoutEffect, useRef } from "react";

export function useCcScrollEffect(listener: () => void) {
  const listenerRef = useRef(listener);
  listenerRef.current = listener;

  const onScroll = useCallback(() => {
    listenerRef.current();
  }, []);

  useLenis(onScroll);

  useLayoutEffect(() => {
    onScroll();
  }, [onScroll]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [onScroll]);
}
